export function getFileExtension({ src, defaultExtension = 'jpg' }) {
    const extensionAtTheEndOfString = /\.([0-9a-z]{1,5})$/;
    const match = src.match(extensionAtTheEndOfString);
    return match ? match[1] : defaultExtension;
}
//# sourceMappingURL=get-file-extension.js.map